//packages
import React, { Component } from 'react';
import PropTypes from 'prop-types';

//styles
import './FieldSet.less'

class FieldSet extends Component {
    static propTypes = {
        title: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ]),
        children: PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.array,
            PropTypes.string,
            PropTypes.number,
        ])
    };

    static defaultProps = {
        children: '',
        title: ''
    };

    render() {
        const {children, title} = this.props;

        return (
            <fieldset className="ir-fieldset">
                <legend>{title}</legend>
                {children}
            </fieldset>
        );
    }

}

export default FieldSet



// WEBPACK FOOTER //
// ./src/components/Modules/FieldSet/FieldSet.js